<template>
  <div
    v-if="focus.length"
    class="focus-badge"
  >
    <span class="focus-label">Focus</span>
    <span
      v-for="f in focus"
      :key="f.label"
      class="focus-pill"
    >
      {{ f.label }}<template v-if="f.name"> · <b>{{ f.name }}</b></template>
      <span
        v-if="f.position"
        class="focus-pos"
      >{{ f.position }}</span>
      <span
        v-else-if="f.label.startsWith('Player ')"
        class="focus-pos focus-pos-missing"
      >position: missing data</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    focus: {
      type: Array,
      required: true
    }
  }
}
</script>
